import type { ContentfulTranslationMessages } from './get-translations'

export const TRANSLATIONS_DEBUG_QUERY_PARAM = 'debugTranslations'

// `null` rather than `undefined`: getServerSideProps props must be JSON-serialisable.
export interface TranslationDebugEntry {
  contentful: string | null
  spreadsheet: string | null
  using: 'contentful' | 'spreadsheet'
}

export type TranslationsDebug = Record<string, TranslationDebugEntry>

export const isTranslationsDebugEnabled = (
  value?: string | string[] | null,
): boolean => {
  const resolved = Array.isArray(value) ? value[0] : value

  return resolved != null && resolved.toLowerCase() !== 'false'
}

export const buildTranslationsDebug = (
  spreadsheet: Record<string, string>,
  contentful: ContentfulTranslationMessages,
): TranslationsDebug =>
  Object.fromEntries(
    Object.keys({ ...spreadsheet, ...contentful })
      .sort((a, b) => a.localeCompare(b))
      .map((key) => [
        key,
        {
          contentful: contentful[key] ?? null,
          spreadsheet: spreadsheet[key] ?? null,
          using: key in contentful ? 'contentful' : 'spreadsheet',
        },
      ]),
  )

export const logTranslationsDebug = (debug: TranslationsDebug): void => {
  const entries = Object.values(debug)
  const fromContentful = entries.filter(
    ({ using }) => using === 'contentful',
  ).length

  window.console.log(
    `[debugTranslations] ${entries.length} keys, ${fromContentful} from Contentful, ${
      entries.length - fromContentful
    } from the spreadsheet`,
    debug,
  )
}
